import { createRoute } from '@backoffice-frontend/common'
import { TripAreaRoutes } from '@backoffice-frontend/trip-api'
import { Button } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'

const poolingDetailUrl = (vehicleId: string) =>
  createRoute(TripAreaRoutes.Vehicle.route, {
    vehicleId,
  })

export const VehicleTripsLink = ({ vehicleId }: { vehicleId: string }) => {
  const { t } = useTranslation()
  const link = poolingDetailUrl(vehicleId)
  return (
    <Button
      aria-label={t('common_details_button')}
      label={t('common_trips_label')}
      onClick={() => {
        window.open(link, '_blank')
      }}
      variant="plain"
      size="compact"
    />
  )
}
